module.exports = __webpack_public_path__ + "svg/new-vipps-small.60de1456caa26a68dd6956b5cecb11c4.svg";